import { Template } from "./types";

export const templates: Template[] = [
    {
        name: "Webseite_Referenten",
        src: "/templates/Webseite_Referenten_Template.png",
        backgroundcolor: "#ededed",
        imageArea: {x: 0, y:0, width: 570, height: 428},
        textAreas: [],
    },
    {
        name: "Speaker Announcement",
        src: "/templates/SpeakerTemplate.png",
        backgroundcolor: "#111111",
        imageArea: {x: 849, y:217, width: 215, height: 215},
        textAreas: [
            {
                id: "presentation_title_part_1",
                derivedFrom: "presentation_title",
                scaleGroup: "presentation_title",
                x: 140, y: 190,
                fontFamily: "Barlow", fontSize: 180, fontWeight: "bold",
                minFontSize:40, autoSize: true, maxHeight: 160,
                textAlign: "left", color: "#111111", maxWidth: 600,
            },
            {
                id: "presentation_title_part_2",
                derivedFrom: "presentation_title",
                scaleGroup: "presentation_title",
                x: 140, y: 330,
                verticalOffsetFrom: "presentation_title_part_1",
                gapAfterPrevious: 30,
                fontFamily: "Barlow", fontSize: 100,
                minFontSize: 30,
                autoSize: true,
                fontWeight: "bold",
                textAlign: "left", color: "#111111", maxWidth: 600,
                maxHeight: 120,
            },
            {
                id: "name",
                description: "The full name of the speaker",
                x: 560, y: 460,
                fontFamily: "Cocon", fontSize: 50, 
                textAlign: "center", color: "#ade8ea",
            },
            {
                id: "date",
                description: "The date of the presentation",
                x: 150, y: 566,
                fontFamily: "Barlow", fontSize: 40, fontWeight: "bold",
                textAlign: "left", color: "#ffffff",
            },
            {
                id: "location",
                description: "The location or venue of the presentation",
                x: 690, y: 566,
                fontFamily: "Barlow", fontSize: 40, fontWeight: "bold",
                textAlign: "left", color: "#ffffff",
            },
        ],
    },
    {
        name: "Exponat Announcement",
        src: "/templates/GameSpotlightTemplate.png",
        backgroundcolor: "#111111",
        imageArea: {x: 500, y:105, width: 700, height: 400},
        textAreas: [
            {
                id: "Name",
                description: "The name of the exponat",
                x: 70, y: 310,
                fontFamily: "Barlow", fontSize: 180, fontWeight: "bold",
                minFontSize:40, autoSize: true, maxHeight: 100,
                textAlign: "left", color: "#83d7dd", maxWidth: 375,
            },
            {
                id: "date",
                description: "The date of the event",
                x: 220, y: 566,
                fontFamily: "Barlow", fontSize: 40, fontWeight: "bold",
                textAlign: "left", color: "#ffffff",
            },
            {
                id: "location",
                description: "The location or venue of the event",
                x: 750, y: 566,
                fontFamily: "Barlow", fontSize: 40, fontWeight: "bold",
                textAlign: "left", color: "#ffffff",
            },
        ],
    },
    {
        name: "GameDays Announcement",
        src: "/templates/GameDaysAnnouncementTemplate.png",
        backgroundcolor: "#111111",
        textAreas: [
            {
                id: "year",
                description:"year of the event",
                x: 460, y: 300,
                fontFamily: "Cocon", fontSize: 62, fontWeight: "bold",
                minFontSize:40, autoSize: true, maxHeight: 70,
                textAlign: "left", color: "#ffffff", maxWidth: 600,
            },
            {
                id: "date",
                description:"day and month of the event in the form of dd.mm. or dd.-dd.mm. If month is given as a name convert it to it's number f",
                x: 310, y: 990,
                fontFamily: "Barlow", fontSize: 40, fontWeight: "bold",
                minFontSize:30, autoSize: true, maxHeight: 50,
                textAlign: "left", color: "#83d7dd", maxWidth: 210,
            },
            {
                id: "location",
                description:"The location or venue of the event",
                x: 621, y: 990,
                fontFamily: "Barlow", fontSize: 40, fontWeight: "bold",
                minFontSize:20, autoSize: true, maxHeight: 50,
                textAlign: "left", color: "#83d7dd", maxWidth: 210,
            },
        ]
    },
    {
        name:"GameDays Landscape Format Light",
        src: "/templates/Template_Querformat_GameDays_Light.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1200, height: 630},
        textAreas: []
    },
    {
        name:"GameDays Landscape Format Dark",
        src: "/templates/Template_Querformat_GameDays_Dark.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1200, height: 630},
        textAreas: []
    },
    {
        name:"AG Landscape Format Light",
        src: "/templates/Template_Querformat_AG_Light.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1200, height: 630},
        textAreas: []
    },
    {
        name:"AG Landscape Format Dark",
        src: "/templates/Template_Querformat_AG_Dark.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1200, height: 630},
        textAreas: []
    },
    {
        name:"GameDays Portrait Format Light",
        src: "/templates/Template_Hochformat_GameDays_Light.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1080, height: 1350},
        textAreas: []
    },
    {
        name:"GameDays Portrait Format Dark",
        src: "/templates/Template_Hochformat_GameDays_Dark.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1080, height: 1350},
        textAreas: []
    },
    {
        name:"AG Portrait Format Light",
        src: "/templates/Template_Hochformat_AG_Light.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1080, height: 1350},
        textAreas: []
    },
    {
        name:"AG Portrait Format Dark",
        src: "/templates/Template_Hochformat_AG_Dark.png",
        backgroundcolor: "#111111",
        imageArea: {x: 0, y:0, width: 1080, height: 1350},
        textAreas: []
    }
    
];